import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class ApiPriorityService {
  private isHighPriorityRequestInProgress = false;
  private videoUploadQueue: Array<{
    videoBlob: Blob, 
    chunkType: any, 
    filePath: any,
    isScreenShare?: boolean
  }> = [];
  private processingQueue = false;

  constructor() {}

  setHighPriorityRequestInProgress(status: boolean) {
    this.isHighPriorityRequestInProgress = status;
    
    // If high priority request finished, start processing the queue
    if (!status && this.videoUploadQueue.length > 0 && !this.processingQueue) {
      this.processVideoUploadQueue();
    }
  }

  isHighPriorityActive(): boolean {
    return this.isHighPriorityRequestInProgress;
  }

  queueVideoUpload(videoBlob: Blob, chunkType: any, filePath: any, isScreenShare: boolean = false) {
    this.videoUploadQueue.push({ videoBlob, chunkType, filePath, isScreenShare });
    
    // Only process queue if no high-priority requests are active
    if (!this.isHighPriorityRequestInProgress && !this.processingQueue) {
      this.processVideoUploadQueue();
    }
  }

  private async processVideoUploadQueue() {
    if (this.videoUploadQueue.length === 0) return;
    
    this.processingQueue = true;
    
    // Process all items in the queue
    while (this.videoUploadQueue.length > 0 && !this.isHighPriorityRequestInProgress) {
      try {
        const item = this.videoUploadQueue.shift();
        
        // Dispatch appropriate event based on whether it's a screen share
        const eventName = item.isScreenShare ? 'processScreenVideoUpload' : 'processVideoUpload';
        const uploadEvent = new CustomEvent(eventName, { 
          detail: item 
        });
        window.dispatchEvent(uploadEvent);
        
        // Wait a bit before processing next item
        await new Promise(resolve => setTimeout(resolve, 500));
      } catch (error) {
        console.error('Error processing video upload queue', error);
      }
    }
    
    this.processingQueue = false;
  }
}